import { findElement, isDisabled, describeElement } from './collect'

const EXECUTABLE = ['click', 'fill', 'select']
const VALUE_MAX = 500
const fail = reason => ({ ok: false, reason })
const TEXT_TYPES = ['text', 'search', 'email', 'url', 'tel', 'number', 'password']
// 只写文本类输入框：textarea，或 type 缺省/属于文本类的 input；只读的不写。
const fillable = control => {
  if (control.readOnly) return false
  if (control.tagName === 'TEXTAREA') return true
  if (control.tagName !== 'INPUT') return false
  const type = control.getAttribute('type')
  return type === null || TEXT_TYPES.includes(type.trim().toLowerCase())
}

// 模型可能照抄清单或页面上的写法（「1.4.49（开发版）」「v1.4.49 · 开发版」）。这些写法都要精确对应到一个选项，不做模糊匹配。
const findOption = (control, value) => {
  const options = [...control.options].filter(option => !option.disabled)
  const text = value.trim()
  const plain = text.replace(/（[^（）]*）$/, '').replace(/ · .*$/, '').replace(/^v(?=\d)/i, '').trim()
  return options.find(option => option.value === value)
    || options.find(option => option.textContent.trim() === text)
    || options.find(option => option.value === plain)
}

/** iframe 发来的操作一律按注册表 + 实时 DOM 复验；宿主是唯一安全边界。 */
export function executeAction({ pageKey, id, op, value } = {}, { currentPageKey, root = document } = {}) {
  if (!pageKey || pageKey !== currentPageKey) return fail('页面已切换，未执行')
  const target = typeof id === 'string' ? findElement(currentPageKey, id, root) : undefined
  if (!target) return fail('该元素已不在当前页面')
  if (!EXECUTABLE.includes(op) || !target.entry.ops.includes(op)) return fail('该按钮需要你自己点击')
  if (isDisabled(target)) {
    const reason = describeElement(target).state?.reason
    return fail(reason ? `按钮当前不可用（${reason}）` : '按钮当前不可用')
  }
  const control = target.entry.control?.(target.el) || target.el
  if (op === 'click') { control.click(); return { ok: true } }
  if (typeof value !== 'string' || value.length > VALUE_MAX) return fail('填写的值无效')
  if (op === 'fill') {
    if (!fillable(control)) return fail('这里不能直接填写')
    control.value = value
  } else {
    if (control.tagName !== 'SELECT') return fail('这里不能直接选择')
    const option = findOption(control, value)
    if (!option) return fail(`没有这个选项：${value.slice(0, 40)}`)
    control.value = option.value
  }
  // Vue v-model：input 框听 input，select 听 change；两个都派发。
  control.dispatchEvent(new Event('input', { bubbles: true }))
  control.dispatchEvent(new Event('change', { bubbles: true }))
  return { ok: true }
}
